// extracted by mini-css-extract-plugin
module.exports = {"text":"PremiumMember-module_text_dcA2D","wrapper":"PremiumMember-module_wrapper_dkD5s","mobile":"PremiumMember-module_mobile_2JPTw","icon":"PremiumMember-module_icon_2yHvO"};